import { z } from "zod";
const hash = z.string().regex(/^[a-f0-9]{64}$/);
const publicText = (max) => z
    .string()
    .trim()
    .min(1)
    .max(max)
    .regex(/^(?!\s*$)(?![\s\S]*(?:[hH][tT][tT][pP][sS]?:\/\/|[wW][wW][wW]\.|[rR]\$|[uU][sS]\$))[^\p{C}]+$/u, "Only a public product identity is allowed");
const host = z
    .string()
    .min(3)
    .max(253)
    .regex(/^(?!(?:.*\.)?(?:localhost|local|internal|test|gov\.br|leg\.br|jus\.br)$)(?!.*\.\.)[a-z0-9](?:[a-z0-9.-]*[a-z0-9])?\.[a-z]{2,}$/);
/** Immutable, minimal upload binding. Never contains monetary values, quantities or full rows. */
export const applianceProductDiscoveryTargetSchema = z
    .object({
    version: z.literal("APPLIANCE_PRODUCT_TARGET_V1"),
    targetId: z.string().uuid(),
    uploadId: z.string().uuid(),
    itemId: z.string().regex(/^[^\p{C}/\\]{1,100}$/u),
    identitySha256: hash,
    description: publicText(300),
    sku: publicText(160).nullable(),
    gtin: z
        .string()
        .regex(/^(?:\d{8}|\d{12}|\d{13}|\d{14})$/)
        .nullable(),
    brand: publicText(160).nullable(),
    manufacturerModel: publicText(160).nullable(),
    manufacturerIdentityIds: z.array(z.string().uuid()).max(20),
    sourceIds: z.array(z.string().uuid()).max(20),
    manufacturerHosts: z.array(host).max(20),
})
    .strict()
    .superRefine((value, ctx) => {
    if (value.manufacturerIdentityIds.length !== value.sourceIds.length ||
        value.sourceIds.length !== value.manufacturerHosts.length)
        ctx.addIssue({
            code: "custom",
            path: ["sourceIds"],
            message: "Manufacturer identities, sources and hosts must be parallel registered tuples",
        });
});
export const applianceProductDiscoveryResultSchema = z
    .object({
    version: z.literal("APPLIANCE_PRODUCT_DISCOVERY_V1"),
    targetSha256: hash,
    status: z.enum(["CANDIDATES", "UNRESOLVED"]),
    candidates: z
        .array(z
        .object({
        canonicalUrl: z.string().url().max(2000),
        sourceId: z.string().uuid(),
        manufacturerIdentityId: z.string().uuid(),
        manufacturerModel: publicText(160),
        gtin: z
            .string()
            .regex(/^(?:\d{8}|\d{12}|\d{13}|\d{14})$/)
            .nullable(),
        candidateNcm: z
            .string()
            .regex(/^\d{8}$/)
            .nullable(),
    })
        .strict())
        .max(5),
    reasons: z.array(z.string().regex(/^[A-Z][A-Z0-9_]{1,79}$/)).max(20),
})
    .strict()
    .superRefine((value, ctx) => {
    if (value.status === "CANDIDATES" && value.candidates.length === 0)
        ctx.addIssue({
            code: "custom",
            path: ["candidates"],
            message: "Candidate discovery requires a source URL",
        });
    if (value.status === "UNRESOLVED" && value.candidates.length > 0)
        ctx.addIssue({
            code: "custom",
            path: ["candidates"],
            message: "Unresolved discovery cannot also claim candidates",
        });
    if (value.status === "UNRESOLVED" && value.reasons.length === 0)
        ctx.addIssue({
            code: "custom",
            path: ["reasons"],
            message: "Unresolved discovery requires a reason",
        });
});
//# sourceMappingURL=appliance-product-discovery.js.map